import HtmlDocumentScreen from 'features/urlDocumentScreens/HtmlDocumentScreen/HtmlDocumentScreen';
import React from 'react';

const HtmlDocumentRoute = () => {
  return <HtmlDocumentScreen />;
};

export default HtmlDocumentRoute;
